<script setup lang="ts">
    import {VJoyHighlight} from '@maltjoy/core-vue';
</script>
<template>
    <VJoyHighlight accent class="mui-highlight"><slot /></VJoyHighlight>
</template>

<style lang="scss">
    .mui-highlight.joy-highlight.joy-highlight__accent {
        background-color: var(--joy-color-neutral-0);
        border-color: var(--mui-color-background-revert);
        box-shadow: var(--joy-core-elevation-1);
        margin: var(--joy-core-spacing-6) 0;
    }
</style>
